import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const ArchiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M22.163.6509H1.8365C.8237.6509,0,1.4751,0,2.4878v3.5953c0,.9507.7286,1.7261,1.6553,1.8186v13.6104c0,1.0127.8237,1.837,1.8365,1.837h17.016c1.0127,0,1.837-.8242,1.837-1.837V7.9017c.9265-.0928,1.6553-.8681,1.6553-1.8186v-3.5953c0-1.0127-.8242-1.837-1.837-1.837ZM21.3447,21.5122c0,.4619-.375.8369-.8369.8369H3.4918c-.4614,0-.8364-.375-.8364-.8369V7.9201h18.6893v13.5921ZM23,6.0831c0,.4614-.375.8369-.8369.8369H1.8365c-.4614,0-.8364-.3755-.8364-.8369v-3.5953c0-.4614.375-.8369.8364-.8369h20.3266c.4619,0,.8369.3755.8369.8369v3.5953Z"
        className="primary"
      />
      <path d="M9.0812,12.4666h5.816c.2764,0,.5-.2236.5-.5s-.2236-.5-.5-.5h-5.816c-.2764,0-.5.2236-.5.5s.2236.5.5.5Z" className="primary" />
    </g>
  </svg>
);
export default withCustomIcon(ArchiveIcon);
